import styled, { device, css, themeGet } from "../../../styled";

export const StyledWrap = styled.div`
  padding: 20px;
  ${device.large} {
    padding: 25px;
  }
  ${device.large} {
    padding: 30px;
  }
`;

export const StyledContent = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  ${(props) =>
    props.theme.name === "dark" &&
    css`
      color: ${themeGet("colors.gray500")};
    `}
`;
